import React, { useState } from 'react';
import Modal from '../modal';

const SubscriptionGrid: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [key, setKey] = useState('');

  const titleOption = () => {
    switch (key) {
      case 'VIDA-PSDSD':
        return 'VIDA Parts, Service, Diagnostic & Software Download';
      case 'VIDA-PSD':
        return 'VIDA Parts, Service and Diagnostics';
      case 'VIDA-PS':
        return 'VIDA Parts and Service';
      case 'VIDA-PC':
        return 'VIDA Parts Catalog';
      case 'SABWDS':
        return 'Stand-Alone Bulletin and Wiring Diagram Subscriptions';
      default:
        return 'No Title';
    }
  };

  const bodyOption = () => {
    switch (key) {
      case 'VIDA-PSDSD':
        return (
          <div className="mc">
            <h3>Electronic Parts Catalog</h3>
            <p>
              The VIDA Parts Catalog replaces paper and microfiche for all Volvo
              models back through the Volvo 240. The electronic parts catalog is
              organized by model and model year, and function, e.g., engine,
              body and interior, climate, etc. In the VIDA Parts Catalog, define
              a vehicle profile at the start of a search to find only the parts
              for that model, year, engine, and transmission. A search without a
              vehicle profile will give results for all models using the search
              terms you provide.
            </p>
            <h3>Electronic Service Information</h3>
            <p>
              VIDA service information provides instruction for repair,
              replacement, and overhaul for all models back through model year
              1994. Information is organized by model and model year, and
              vehicle function, e.g., engine, transmission, electrical, climate,
              etc. Defining a vehicle profile, at least by model and model year,
              at the start of a repair is necessary to ensure that only
              appropriate repair methods are presented. VIDA service information
              is linked to the Parts Catalog, allowing you to move back and
              forth between repair information and parts diagrams.
            </p>
            <h3>Vehicle Diagnostics and Fault Tracing Application</h3>
            <p>
              VIDA Diagnostics is an interactive program that can use
              customer-reported symptoms, together with Diagnostic Trouble Codes
              (DTCs) read from the vehicle, to guide a technician through
              diagnostic and repair procedures for model year 1999 and later
              Volvos. VIDA repair procedures often call on a technician to use
              VIDA Diagnostics during the course of electronic module
              replacement or repair.
            </p>
            <p>
              VIDA Diagnostics communicates directly with the vehicle via the
              DiCE Tool (available separately). In this way, VIDA can read and
              clear Diagnostic Trouble Codes (DTCs) from emissions and
              non-emissions systems, and perform many enhanced diagnostic
              functions such as sensor read-out and component activation.
            </p>
            <h3>Vehicle Software Download Application</h3>
            <p>
              VIDA Software Download Application is integrated into the VIDA
              All-in-One Client. It manages retrieval of vehicle software from
              online servers, and manages the download of software into the
              vehicles electronic modules. VIDA Software Download Application
              communicates with the vehicle via the DiCE Tool (available
              separately). The DiCE Tool is a link between the PC and the
              vehicle.
            </p>
            <h4>Optional Volvo Standard Times (VST)</h4>
            <p>
              The times for the different operations are the basic times that a
              technician with the proper training needs to perform the work.
              This is on the assumption that all the correct equipment, hand
              tools, as well as Volvo special tools, are available within the
              work area. The times are continuously updated. This is to
              guarantee high quality information and to ensure the VST remains
              current.
            </p>
            <p>
              Each job has been performed and the times have been studied within
              Volvo Car Customer Services Method Workshop.
            </p>
            <p>
              Any subscription may be extended or renewed for up to one year's
              total duration.
            </p>
            <p>
              A VIDA subscription also provides access, through this bookstore
              and your online profile, to the following information products.
            </p>
            <ul>
              <li>Volvo Service-Parts-Tool Bulletins</li>
              <li>Volvo Technical Journals</li>
              <li>Online Wiring Diagrams 1994-2016*</li>
            </ul>
            <small>
              * (WD for MY16 and new XC90, S90 and V90 and smiliar platform are
              available with a VIDA subscription.)
            </small>
            {/* language=CSS */}
            <style jsx>{`
              .mc {
                font-family: 'Volvo Novum', sans-serif;
              }

              .mc h3,
              .mc h4 {
                margin: 0;
                padding: 0;
                font-weight: 500;
              }

              .mc h3:not(:first-child) {
                margin: 1rem 0 0;
              }

              .mc h4 {
                margin: 1rem 0 0;
              }

              .mc p {
                margin: 0 0 0.5rem;
                font-size: 14px;
              }
            `}</style>
          </div>
        );
      case 'VIDA-PSD':
        return (
          <div className="mc">
            <h3>Electronic Parts Catalog</h3>
            <p>
              The VIDA Parts Catalog replaces paper and microfiche for all Volvo
              models back through the Volvo 240. The electronic parts catalog is
              organized by model and model year, and function, e.g., engine,
              body and interior, climate, etc. In the VIDA Parts Catalog, define
              a vehicle profile at the start of a search to find only the parts
              for that model, year, engine, and transmission. A search without a
              vehicle profile will give results for all models using the search
              terms you provide.
            </p>
            <h3>Electronic Service Information</h3>
            <p>
              VIDA service information provides instruction for repair,
              replacement, and overhaul for all models back through model year
              1994. Information is organized by model and model year, and
              vehicle function, e.g., engine, transmission, electrical, climate,
              etc. Defining a vehicle profile, at least by model and model year,
              at the start of a repair is necessary to ensure that only
              appropriate repair methods are presented. VIDA service information
              is linked to the Parts Catalog, allowing you to move back and
              forth between repair information and parts diagrams.
            </p>
            <h3>Vehicle Diagnostics and Fault Tracing Application</h3>
            <p>
              VIDA Diagnostics is an interactive program that can use
              customer-reported symptoms, together with Diagnostic Trouble Codes
              (DTCs) read from the vehicle, to guide a technician through
              diagnostic and repair procedures for model year 1999 and later
              Volvos. VIDA repair procedures often call on a technician to use
              VIDA Diagnostics during the course of electronic module
              replacement or repair.
            </p>
            <p>
              VIDA Diagnostics communicates directly with the vehicle via the
              DiCE Tool (available separately). In this way, VIDA can read and
              clear Diagnostic Trouble Codes (DTCs) from emissions and
              non-emissions systems, and perform many enhanced diagnostic
              functions such as sensor read-out and component activation.
            </p>
            <h4>Optional Volvo Standard Times (VST)</h4>
            <p>
              The times for the different operations are the basic times that a
              technician with the proper training needs to perform the work.
              This is on the assumption that all the correct equipment, hand
              tools, as well as Volvo special tools, are available within the
              work area. The times are continuously updated. This is to
              guarantee high quality information and to ensure the VST remains
              current.
            </p>
            <p>
              Each job has been performed and the times have been studied within
              Volvo Car Customer Services Method Workshop.
            </p>
            <p>
              Any subscription may be extended or renewed for up to one year's
              total duration.
            </p>
            <p>
              A VIDA subscription also provides access, through this bookstore
              and your online profile, to the following information products.
            </p>
            <ul>
              <li>Volvo Service-Parts-Tool Bulletins</li>
              <li>Volvo Technical Journals</li>
              <li>Online Wiring Diagrams 1994-2016*</li>
            </ul>
            <small>
              * (WD for MY16 and new XC90, S90 and V90 and smiliar platform are
              available with a VIDA subscription.)
            </small>
            {/* language=CSS */}
            <style jsx>{`
              .mc {
                font-family: 'Volvo Novum', sans-serif;
              }

              .mc h3,
              .mc h4 {
                margin: 0;
                padding: 0;
                font-weight: 500;
              }

              .mc h3:not(:first-child) {
                margin: 1rem 0 0;
              }

              .mc h4 {
                margin: 1rem 0 0;
              }

              .mc p {
                margin: 0 0 0.5rem;
                font-size: 14px;
              }
            `}</style>
          </div>
        );
      case 'VIDA-PS':
        return (
          <div className="mc">
            <h3>Electronic Parts Catalog</h3>
            <p>
              The VIDA Parts Catalog replaces paper and microfiche for all Volvo
              models back through the Volvo 240. The electronic parts catalog is
              organized by model and model year, and function, e.g., engine,
              body and interior, climate, etc. In the VIDA Parts Catalog, define
              a vehicle profile at the start of a search to find only the parts
              for that model, year, engine, and transmission. A search without a
              vehicle profile will give results for all models using the search
              terms you provide.
            </p>
            <h3>Electronic Service Information</h3>
            <p>
              VIDA service information provides instruction for repair,
              replacement, and overhaul for all models back through model year
              1994. Information is organized by model and model year, and
              vehicle function, e.g., engine, transmission, electrical, climate,
              etc. Defining a vehicle profile, at least by model and model year,
              at the start of a repair is necessary to ensure that only
              appropriate repair methods are presented. VIDA service information
              is linked to the Parts Catalog, allowing you to move back and
              forth between repair information and parts diagrams.
            </p>
            <h4>Optional Volvo Standard Times (VST)</h4>
            <p>
              The times for the different operations are the basic times that a
              technician with the proper training needs to perform the work.
              This is on the assumption that all the correct equipment, hand
              tools, as well as Volvo special tools, are available within the
              work area. The times are continuously updated. This is to
              guarantee high quality information and to ensure the VST remains
              current.
            </p>
            <p>
              Each job has been performed and the times have been studied within
              Volvo Car Customer Services Method Workshop.
            </p>
            <p>
              Any subscription may be extended or renewed for up to one year's
              total duration.
            </p>
            <p>
              A VIDA subscription also provides access, through this bookstore
              and your online profile, to the following information products.
            </p>
            <ul>
              <li>Volvo Service-Parts-Tool Bulletins</li>
              <li>Volvo Technical Journals</li>
              <li>Online Wiring Diagrams 1994-2016*</li>
            </ul>
            <small>
              * (WD for MY16 and new XC90, S90 and V90 and smiliar platform are
              available with a VIDA subscription.)
            </small>
            {/* language=CSS */}
            <style jsx>{`
              .mc {
                font-family: 'Volvo Novum', sans-serif;
              }

              .mc h3,
              .mc h4 {
                margin: 0;
                padding: 0;
                font-weight: 500;
              }

              .mc h3:not(:first-child) {
                margin: 1rem 0 0;
              }

              .mc h4 {
                margin: 1rem 0 0;
              }

              .mc p {
                margin: 0 0 0.5rem;
                font-size: 14px;
              }
            `}</style>
          </div>
        );
      case 'VIDA-PC':
        return (
          <div className="mc">
            <h3>Electronic Parts Catalog</h3>
            <p>
              The VIDA Parts Catalog replaces paper and microfiche for all Volvo
              models back through the Volvo 240. The electronic parts catalog is
              organized by model and model year, and function, e.g., engine,
              body and interior, climate, etc. In the VIDA Parts Catalog, define
              a vehicle profile at the start of a search to find only the parts
              for that model, year, engine, and transmission. A search without a
              vehicle profile will give results for all models using the search
              terms you provide.
            </p>
            <h4>Optional Volvo Standard Times (VST)</h4>
            <p>
              The times for the different operations are the basic times that a
              technician with the proper training needs to perform the work.
              This is on the assumption that all the correct equipment, hand
              tools, as well as Volvo special tools, are available within the
              work area. The times are continuously updated. This is to
              guarantee high quality information and to ensure the VST remains
              current.
            </p>
            <p>
              Each job has been performed and the times have been studied within
              Volvo Car Customer Services Method Workshop.
            </p>
            <p>
              Any subscription may be extended or renewed for up to one year's
              total duration.
            </p>
            {/* language=CSS */}
            <style jsx>{`
              .mc {
                font-family: 'Volvo Novum', sans-serif;
              }

              .mc h3,
              .mc h4 {
                margin: 0;
                padding: 0;
                font-weight: 500;
              }

              .mc h3:not(:first-child) {
                margin: 1rem 0 0;
              }

              .mc h4 {
                margin: 1rem 0 0;
              }

              .mc p {
                margin: 0 0 0.5rem;
                font-size: 14px;
              }
            `}</style>
          </div>
        );
      case 'SABWDS':
        return (
          <div className="mc">
            <p>
              Individual bulletins types and online wiring diagrams may be
              subscribed to separately. However, if you subscribe to any VIDA
              package except "Parts Catalog only," Service Bulletins, Technical
              Journals, and Online Wiring Diagrams will automatically be
              included. A Safety Data Sheet (SDS) subscription may be ordered
              separately.
            </p>
            <h3>Service-Parts-Tool Bulletins</h3>
            <p>
              Volvo Service, Parts and Tools bulletins include all supplemental
              bulletins regarding service, maintenance, parts, and special
              tools. This online subscription provides access to all of these
              bulletins for all Volvo models sold in North America.
            </p>
            <h3>Technical Journals</h3>
            <p>
              Volvo Technical Journals are technical bulletins, developed within
              North America, that provide supplemental service methods
              specifically for North American-market vehicles. Technical
              Journals have replaced Service Bulletins, in that respect, for
              model years 2000 and later. Therefore, newer supplemental service
              methods will be found in Retail Technical Journals.
            </p>
            <p>
              This online subscription provides access to all active Technical
              Journals for all Volvo models sold in North America.
            </p>
            <h3>Safety Data Sheets</h3>
            <p>
              Volvo Safety Data Sheets provide chemical safety data and
              emergency contact information for all genuine Volvo Parts that
              require safety data information. This online subscription provides
              access to all active Safety Data Sheets for all Volvo parts sold
              in the U.S. Safety Data Sheets are generally numbered to match
              corresponding Volvo part numbers.
            </p>
            <h3>Online Wiring Diagrams</h3>
            <p>
              VIDA provides wiring diagrams dating back through model year 2000.
              This supplemental Online Wiring Diagram subscription, with wiring
              diagrams dating back to model year 1994, is also included in the
              above-mentioned VIDA subscriptions.
            </p>
            <p>
              This subscription, which may be useful to technicians who service
              models between 1994 and 1999, and who already have printed service
              manuals, may also be purchased separately.
            </p>
            <p>
              This subscription only includes wiring diagrams up to MY16. For
              MY16 XC90, S90 and V90 and all later model years please purchase a
              VIDA subscription.
            </p>
            <h3>Service Product Journals</h3>
            <p>
              A service product journal (SPJ) is an announcement which contains
              information about the services and applications provided by Volvo
              Cars Customer Service. In short, all information that is not
              related to a vehicle (e.g. car models, engines etc.) are presented
              as an SPJ.
            </p>
            <small>
              * Any subscription may be extended or renewed for up to one year's
              total duration.
            </small>
            {/* language=CSS */}
            <style jsx>{`
              .mc {
                font-family: 'Volvo Novum', sans-serif;
              }

              .mc h3,
              .mc h4 {
                margin: 0;
                padding: 0;
                font-weight: 500;
              }

              .mc h3:not(:first-child) {
                margin: 1rem 0 0;
              }

              .mc h4 {
                margin: 1rem 0 0;
              }

              .mc p {
                margin: 0 0 0.5rem;
                font-size: 14px;
              }
            `}</style>
          </div>
        );
      default:
        return 'No Content';
    }
  };

  return (
    <div className="subscription-grid">
      {key !== '' && (
        <Modal
          defaultValue={open}
          title={titleOption()}
          body={bodyOption()}
          onClose={() => {
            setKey('');
            setOpen(false);
          }}
          padding="4rem"
        />
      )}
      <div className="subscription-tile header">
        <span>
          Description (click the subscriptions below for more information)
        </span>
        <span>3 days</span>
        <span>30 days</span>
        <span>365 days</span>
      </div>
      <div
        className="subscription-tile"
        onClick={() => {
          setKey('VIDA-PSDSD');
          setOpen(true);
        }}
      >
        <span>
          VIDA Parts, Service, Diagnostics and Software Download
          <br />
          <small>
            Note that each Software Download has its own part number and cost.
          </small>
        </span>
        <span>$73.14</span>
        <span>$648.22</span>
        <span>$7547.76</span>
      </div>
      <div
        className="subscription-tile vst"
        onClick={() => {
          setKey('VIDA-PSDSD');
          setOpen(true);
        }}
      >
        <span>with optional VST</span>
        <span>$82.03</span>
        <span>$660.92</span>
        <span>$7702.36</span>
      </div>
      <div
        className="subscription-tile"
        onClick={() => {
          setKey('VIDA-PSD');
          setOpen(true);
        }}
      >
        <span>VIDA Parts, Service and Diagnostics</span>
        <span>$48.15</span>
        <span>$417.93</span>
        <span>$4860.29</span>
      </div>
      <div
        className="subscription-tile vst"
        onClick={() => {
          setKey('VIDA-PSD');
          setOpen(true);
        }}
      >
        <span>with optional VST</span>
        <span>$57.04</span>
        <span>$430.64</span>
        <span>$5014.89</span>
      </div>
      <div
        className="subscription-tile"
        onClick={() => {
          setKey('VIDA-PS');
          setOpen(true);
        }}
      >
        <span>VIDA Parts and Service</span>
        <span>$21.04</span>
        <span>$184.96</span>
        <span>$2213.06</span>
      </div>
      <div
        className="subscription-tile vst"
        onClick={() => {
          setKey('VIDA-PS');
          setOpen(true);
        }}
      >
        <span>with optional VST</span>
        <span>$29.93</span>
        <span>$197.67</span>
        <span>$2367.67</span>
      </div>
      <div
        className="subscription-tile"
        onClick={() => {
          setKey('VIDA-PC');
          setOpen(true);
        }}
      >
        <span>VIDA Parts Catalog</span>
        <span>$11.30</span>
        <span>$34.45</span>
        <span>$210.80</span>
      </div>
      <div
        className="subscription-tile vst"
        onClick={() => {
          setKey('VIDA-PC');
          setOpen(true);
        }}
      >
        <span>with optional VST</span>
        <span>$20.19</span>
        <span>$47.16</span>
        <span>$365.41</span>
      </div>
      <div
        className="subscription-tile"
        onClick={() => {
          setKey('SABWDS');
          setOpen(true);
        }}
      >
        <span>Stand-Alone Bulletin and Wiring Diagram Subscriptions</span>
        <span />
        <span />
        <span />
      </div>
      <div className="subscription-tile">
        <span>Service-Parts-Tool Bulletins</span>
        <span>$2.50</span>
        <span>$17.50</span>
        <span>$110.00</span>
      </div>
      <div className="subscription-tile">
        <span>Technical Journals</span>
        <span>$2.50</span>
        <span>$17.50</span>
        <span>$110.00</span>
      </div>
      <div className="subscription-tile">
        <span>Safety Data Sheets</span>
        <span>$2.50</span>
        <span>$17.50</span>
        <span>$110.00</span>
      </div>
      <div className="subscription-tile">
        <span>Quality Bulletins</span>
        <span>$2.50</span>
        <span>$17.50</span>
        <span>$110.00</span>
      </div>
      <div className="subscription-tile">
        <span>
          Legacy Wiring Diagrams pre-SPA and CMA Platform Cars
          <br />
          <small>
            WD for all SPA and CMA cars MY16 and newer and all vehicles MY19 and
            newer are integrated into VIDA and should be only accessed through
            VIDA
          </small>
        </span>
        <span>$3.50</span>
        <span>$27.51</span>
        <span>$195.00</span>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .subscription-grid {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          padding: 1rem 0 2rem;
        }

        .subscription-tile {
          display: flex;
        }

        .subscription-tile span {
          flex: 1 0 10%;
          cursor: pointer;
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          font-weight: 400;
          box-sizing: border-box;
        }

        .subscription-tile span:first-child {
          flex: 1 0 70%;
        }

        .subscription-tile.header span {
          color: #707070;
          padding: 0 0 1rem;
          border-bottom: 1px solid #ddd;
        }

        .subscription-tile.vst span:first-child {
          text-align: right;
          padding-right: 1rem;
          color: #707070;
        }

        .subscription-tile span small {
          color: #707070;
        }
      `}</style>
    </div>
  );
};

export default SubscriptionGrid;
